var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", staticStyle: { background: "#f4f5f7" } },
    [
      _c("div", { staticClass: "index-top flex flex-spacebetween" }, [
        _c(
          "div",
          { staticClass: "index-left" },
          [
            _c(
              "BjDivider",
              { staticStyle: { padding: "10px 0", margin: "0" } },
              [_vm._v(_vm._s(_vm.$t("homePage.Todolist")))]
            ),
            _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "width25" }, [
                _c("div", { staticClass: "index-title textaligncenter" }, [
                  _vm._v(_vm._s(_vm.$t("route.BusinessInbound"))),
                ]),
                _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("route.BusinessPurchaseOrderCsgAdminIndex"))
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "te",
                      on: {
                        click: function ($event) {
                          return _vm.gotoPage(
                            "BusinessPurchaseOrderCsgAdminIndex"
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.dataInfo2.openReceiptNum || 0))]
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "width25",
                  staticStyle: { "border-left": "2px dashed #f5f5f5" },
                },
                [
                  _c("div", { staticClass: "index-title textaligncenter" }, [
                    _vm._v(_vm._s(_vm.$t("route.BusinessStockDelivery"))),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("homePage.New")))]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessAbnormalOrderSTOCK")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.newOrderNum || 0))]
                    ),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("homePage.Processing")))]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage(
                              "BusinessAbnormalOrderPROCESSINGOrder"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.pendingOrderNum || 0))]
                    ),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("homePage.Error")))]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessAbnormalOrderANOMALY")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.exceptionOrderNum || 0))]
                    ),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("route.BusinessOrderShort"))),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage(
                              "BusinessAbnormalOrderOUTOFSTOCK"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.outOfStockOrderNum || 0))]
                    ),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("route.BusinessAbnormalOrderWAIRING"))
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessAbnormalOrderWAIRING")
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.dataInfo2.collectPendingOrderNum || 0)
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("route.BusinessAbnormalOrderCOLLECTPENDING")
                        )
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage(
                              "BusinessAbnormalOrderCOLLECTPENDING"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.waitingOrderNum || 0))]
                    ),
                  ]),
                  !_vm.$store.getters.cusId
                    ? _c(
                        "div",
                        { staticClass: "flex-align flex-spacebetween" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("route.BusinessAbnormalOrderUrgent")
                              )
                            ),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "te",
                              on: {
                                click: function ($event) {
                                  return _vm.gotoPage(
                                    "BusinessAbnormalOrderUrgent"
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.dataInfo2.urgentOrderNum || 0))]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "width25",
                  staticStyle: { "border-left": "2px dashed #f5f5f5" },
                },
                [
                  _c("div", { staticClass: "index-title textaligncenter" }, [
                    _vm._v(_vm._s(_vm.$t("route.BusinessAfter"))),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("homePage.InProcess")))]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessOpenReturnList")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.waitingReturnOrderNum || 0))]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "width25",
                  staticStyle: { "border-left": "2px dashed #f5f5f5" },
                },
                [
                  _c("div", { staticClass: "index-title textaligncenter" }, [
                    _vm._v(_vm._s(_vm.$t("route.BusinessWorkorder"))),
                  ]),
                  _vm.$store.getters.cusId
                    ? _c(
                        "div",
                        { staticClass: "flex-align flex-spacebetween" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("homePage.Draft"))),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "te",
                              on: {
                                click: function ($event) {
                                  return _vm.gotoPage(
                                    "BusinessOpenWorkorderList",
                                    { tabIndex: 1 }
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.dataInfo2.draftTicketNum || 0))]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("homePage.ApprovalPending"))),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessOpenWorkorderList", {
                              tabIndex: 2,
                            })
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.auditTicketNum || 0))]
                    ),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("homePage.AwaitingProcessing"))),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessOpenWorkorderList", {
                              tabIndex: 3,
                            })
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.waitProcessTicketNum || 0))]
                    ),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("homePage.InProgress")))]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessOpenWorkorderList", {
                              tabIndex: 4,
                            })
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.pendingTicketNum || 0))]
                    ),
                  ]),
                  _c("div", { staticClass: "flex-align flex-spacebetween" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("homePage.ApprovalRejected"))),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "te",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessOpenWorkorderList", {
                              tabIndex: 6,
                            })
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataInfo2.failTicketNum || 0))]
                    ),
                  ]),
                  !_vm.$store.getters.cusId
                    ? _c(
                        "div",
                        { staticClass: "flex-align flex-spacebetween" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("workOrderList.Confirm"))),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "te",
                              on: {
                                click: function ($event) {
                                  return _vm.gotoPage(
                                    "BusinessOpenWorkorderList",
                                    { tabIndex: 9 }
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.dataInfo2.confirmedTicketNum || 0)
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "index-right" },
          [
            _c(
              "BjDivider",
              { staticStyle: { padding: "10px 0", margin: "0" } },
              [_vm._v(_vm._s(_vm.$t("homePage.QuickAccess")))]
            ),
            _c(
              "div",
              {
                staticClass: "flex-align flex-spacebetween",
                staticStyle: { margin: "10px 0 5px" },
              },
              [
                _c("div", { staticStyle: { "font-size": "26px" } }, [
                  _vm._v(_vm._s(_vm.$store.getters.userInfo.loginName)),
                ]),
                _vm.$store.getters.cusId
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "12px",
                          "line-height": "20px",
                        },
                      },
                      [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("homePage.SalesManager")) +
                              "：" +
                              _vm._s(_vm.$store.getters.userInfo.csgSales)
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("homePage.CustomerService")) +
                              "：" +
                              _vm._s(_vm.$store.getters.userInfo.csgCustomer)
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              { staticClass: "flex-align flex-wrap flex-spacebetween" },
              [
                _vm.$store.getters.cusId
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex-align flex flex-column index-right-bg",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessPurchaseOrderCsgAdd")
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "index-right-img",
                          attrs: { src: require("@/assets/img/home1.png") },
                        }),
                        _c("span", { staticClass: "index-right-text" }, [
                          _vm._v(_vm._s(_vm.$t("homePage.AddInbound"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
                !_vm.$store.getters.cusId
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex-align flex flex-column index-right-bg",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage(
                              "BusinessPurchaseOrderCsgAdminIndex"
                            )
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "index-right-img",
                          attrs: { src: require("@/assets/img/home1.png") },
                        }),
                        _c("span", { staticClass: "index-right-text" }, [
                          _vm._v(_vm._s(_vm.$t("homePage.Inbound"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.$store.getters.cusId
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-align flex-column index-right-bg",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("CSGGoodsSkuOrdinaryAdd")
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "index-right-img",
                          attrs: { src: require("@/assets/img/home2.png") },
                        }),
                        _c("span", { staticClass: "index-right-text" }, [
                          _vm._v(_vm._s(_vm.$t("homePage.AddProduct"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
                !_vm.$store.getters.cusId
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-align flex-column index-right-bg",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("CSGGoodsSkuOrdinaryIndex")
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "index-right-img",
                          attrs: { src: require("@/assets/img/home2.png") },
                        }),
                        _c("span", { staticClass: "index-right-text" }, [
                          _vm._v(_vm._s(_vm.$t("homePage.Product"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "flex-align flex-column index-right-bg",
                    on: {
                      click: function ($event) {
                        return _vm.gotoPage("BusinessStockSearchCSG")
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "index-right-img",
                      attrs: { src: require("@/assets/img/home3.png") },
                    }),
                    _c("span", { staticClass: "index-right-text" }, [
                      _vm._v(_vm._s(_vm.$t("homePage.Inventory"))),
                    ]),
                  ]
                ),
                _vm.$store.getters.cusId
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-align flex-column index-right-bg",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessAddThirdOrderCSGView")
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "index-right-img",
                          attrs: { src: require("@/assets/img/home4.png") },
                        }),
                        _c("span", { staticClass: "index-right-text" }, [
                          _vm._v(_vm._s(_vm.$t("homePage.AddOutbound"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
                !_vm.$store.getters.cusId
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-align flex-column index-right-bg",
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage("BusinessAbnormalOrderSTOCK")
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "index-right-img",
                          attrs: { src: require("@/assets/img/home4.png") },
                        }),
                        _c("span", { staticClass: "index-right-text" }, [
                          _vm._v(_vm._s(_vm.$t("homePage.Outbound"))),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "flex-align flex-column index-right-bg",
                    on: {
                      click: function ($event) {
                        return _vm.gotoPage("BusinessAfterReturnAdd")
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "index-right-img",
                      attrs: { src: require("@/assets/img/home5.png") },
                    }),
                    _c("span", { staticClass: "index-right-text" }, [
                      _vm._v(_vm._s(_vm.$t("homePage.AddReturn"))),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-align flex-column index-right-bg",
                    on: {
                      click: function ($event) {
                        return _vm.gotoPage("BusinessWorkorderListForm", {
                          type: "add",
                        })
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "index-right-img",
                      attrs: { src: require("@/assets/img/home6.png") },
                    }),
                    _c("span", { staticClass: "index-right-text" }, [
                      _vm._v(_vm._s(_vm.$t("homePage.AddTicket"))),
                    ]),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "index-top flex flex-spacebetween" }, [
        _c("div", { staticClass: "index-bottom" }, [
          _c(
            "div",
            {
              staticClass: "index-left",
              staticStyle: {
                width: "100%",
                "margin-top": "20px",
                "padding-bottom": "40px",
              },
            },
            [
              _c(
                "BjDivider",
                { staticStyle: { padding: "10px 0", margin: "0" } },
                [_vm._v(_vm._s(_vm.$t("homePage.KeyData")))]
              ),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "width16" }, [
                  _c("div", { staticClass: "index-title" }, [
                    _vm._v(_vm._s(_vm.$t("homePage.Date"))),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("homePage.Yesterday")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("homePage.Last7Days")))]),
                  _c("div", [_vm._v(_vm._s(_vm.$t("homePage.Last30Days")))]),
                ]),
                _c("div", { staticClass: "width16 textalignright" }, [
                  _c("div", { staticClass: "index-title" }, [
                    _vm._v(_vm._s(_vm.$t("homePage.TotalOutbound"))),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.yesterdayCountAllOrder || 0)),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.last7DaysCountAllOrder || 0)),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.last30DaysCountAllOrder || 0)),
                  ]),
                ]),
                _c("div", { staticClass: "width16 textalignright" }, [
                  _c("div", { staticClass: "index-title" }, [
                    _vm._v(_vm._s(_vm.$t("homePage.ShippedOutbound"))),
                  ]),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.dataInfo.yesterdayCountCompleteOrder || 0)
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.dataInfo.last7DaysCountCompleteOrder || 0)
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.dataInfo.last30DaysCountCompleteOrder || 0)
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "width16 textalignright" }, [
                  _c("div", { staticClass: "index-title" }, [
                    _vm._v(_vm._s(_vm.$t("homePage.TotalInbound"))),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.yesterdayCountAllInbound || 0)),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.last7DaysCountAllInbound || 0)),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.last30DaysCountAllInbound || 0)),
                  ]),
                ]),
                _c("div", { staticClass: "width16 textalignright" }, [
                  _c("div", { staticClass: "index-title" }, [
                    _vm._v(_vm._s(_vm.$t("homePage.ShippedInbound"))),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.yesterdayCountDoneInbound || 0)),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.last7DaysCountDoneInbound || 0)),
                  ]),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.dataInfo.last30DaysCountDoneInbound || 0)
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "width16 textalignright" }, [
                  _c("div", { staticClass: "index-title" }, [
                    _vm._v(_vm._s(_vm.$t("homePage.TotalReturn"))),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.yesterdayCountAllReturn || 0)),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.last7DaysCountAllReturn || 0)),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.dataInfo.last30DaysCountAllReturn || 0)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "index-left",
              staticStyle: {
                width: "100%",
                "margin-top": "20px",
                "padding-bottom": "40px",
              },
            },
            [
              _c(
                "BjDivider",
                { staticStyle: { padding: "10px 0", margin: "0" } },
                [_vm._v(_vm._s(_vm.$t("homePage.BasicStatistic")))]
              ),
              !_vm.$store.getters.cusId
                ? _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "width16 flex-align",
                        staticStyle: { "margin-top": "25px" },
                      },
                      [
                        _c("img", {
                          staticClass: "index-left-img",
                          attrs: { src: require("@/assets/img/home_bt0.png") },
                        }),
                        _c("div", [
                          _c("div", { staticClass: "index-bottom-text" }, [
                            _vm._v(_vm._s(_vm.dataInfo2.customerNum || 0)),
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("homePage.TotalCustomers"))),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "width16 flex-align",
                        staticStyle: { "margin-top": "25px" },
                      },
                      [
                        _c("img", {
                          staticClass: "index-left-img",
                          attrs: { src: require("@/assets/img/home_bt1.png") },
                        }),
                        _c("div", [
                          _c("div", { staticClass: "index-bottom-text" }, [
                            _vm._v(_vm._s(_vm.dataInfo2.completeOrderNum || 0)),
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("homePage.OrdersShipped"))),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "width16 flex-align",
                        staticStyle: { "margin-top": "25px" },
                      },
                      [
                        _c("img", {
                          staticClass: "index-left-img",
                          attrs: { src: require("@/assets/img/home_bt2.png") },
                        }),
                        _c("div", [
                          _c("div", { staticClass: "index-bottom-text" }, [
                            _vm._v(_vm._s(_vm.dataInfo2.availableSkuNum || 0)),
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("homePage.AvailableSKU"))),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "width16 flex-align",
                        staticStyle: { "margin-top": "25px" },
                      },
                      [
                        _c("img", {
                          staticClass: "index-left-img",
                          attrs: { src: require("@/assets/img/home_bt3.png") },
                        }),
                        _c("div", [
                          _c("div", { staticClass: "index-bottom-text" }, [
                            _vm._v(_vm._s(_vm.dataInfo2.availableInvNum || 0)),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("homePage.AvailableInventory"))
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "width16 flex-align",
                        staticStyle: { "margin-top": "25px" },
                      },
                      [
                        _c("img", {
                          staticClass: "index-left-img",
                          attrs: { src: require("@/assets/img/home_bt4.png") },
                        }),
                        _c("div", [
                          _c("div", { staticClass: "index-bottom-text" }, [
                            _vm._v(_vm._s(_vm.dataInfo2.availableShop || 0)),
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("homePage.AuthorizedStore"))),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "width16 flex-align",
                        staticStyle: { "margin-top": "25px" },
                      },
                      [
                        _c("img", {
                          staticClass: "index-left-img",
                          attrs: { src: require("@/assets/img/home_bt5.png") },
                        }),
                        _c("div", [
                          _c("div", { staticClass: "index-bottom-text" }, [
                            _vm._v(
                              _vm._s(_vm.dataInfo2.processedReturnOrderNum || 0)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("homePage.ProcessedReturn"))),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _c("div", { staticClass: "flex" }, [
                    _c("div", { staticClass: "width20 flex-align" }, [
                      _c("img", {
                        staticClass: "index-left-img",
                        attrs: { src: require("@/assets/img/home_bt1.png") },
                      }),
                      _c("div", [
                        _c("div", { staticClass: "index-bottom-text" }, [
                          _vm._v(_vm._s(_vm.dataInfo2.completeOrderNum || 0)),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("homePage.OrdersShipped"))),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "width20 flex-align" }, [
                      _c("img", {
                        staticClass: "index-left-img",
                        attrs: { src: require("@/assets/img/home_bt2.png") },
                      }),
                      _c("div", [
                        _c("div", { staticClass: "index-bottom-text" }, [
                          _vm._v(_vm._s(_vm.dataInfo2.availableSkuNum || 0)),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("homePage.AvailableSKU"))),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "width20 flex-align" }, [
                      _c("img", {
                        staticClass: "index-left-img",
                        attrs: { src: require("@/assets/img/home_bt3.png") },
                      }),
                      _c("div", [
                        _c("div", { staticClass: "index-bottom-text" }, [
                          _vm._v(_vm._s(_vm.dataInfo2.availableInvNum || 0)),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("homePage.AvailableInventory"))),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "width20 flex-align" }, [
                      _c("img", {
                        staticClass: "index-left-img",
                        attrs: { src: require("@/assets/img/home_bt4.png") },
                      }),
                      _c("div", [
                        _c("div", { staticClass: "index-bottom-text" }, [
                          _vm._v(_vm._s(_vm.dataInfo2.availableShop || 0)),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("homePage.AuthorizedStore"))),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "width20 flex-align" }, [
                      _c("img", {
                        staticClass: "index-left-img",
                        attrs: { src: require("@/assets/img/home_bt5.png") },
                      }),
                      _c("div", [
                        _c("div", { staticClass: "index-bottom-text" }, [
                          _vm._v(
                            _vm._s(_vm.dataInfo2.processedReturnOrderNum || 0)
                          ),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("homePage.ProcessedReturn"))),
                        ]),
                      ]),
                    ]),
                  ]),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "index-right",
            staticStyle: {
              "margin-top": "20px",
              "font-size": "10px",
              "line-height": "18px",
            },
          },
          [
            _c(
              "BjDivider",
              { staticStyle: { padding: "10px 0", margin: "6px" } },
              [_vm._v(_vm._s(_vm.$t("homePage.OutboundOrder")))]
            ),
            _c(
              "el-tabs",
              {
                attrs: { value: _vm.tabStatus, type: "card" },
                on: { "tab-click": _vm.handleTabClick },
              },
              _vm._l(_vm.CSG_ORDER_LIST, function (item, index) {
                return _c("el-tab-pane", {
                  key: index,
                  attrs: { label: _vm.$t(item.label), name: item.value },
                })
              }),
              1
            ),
            _vm.tabStatus == 1
              ? _c(
                  "div",
                  _vm._l(_vm.dataList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flex-spacebetween" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "ellipsis",
                            staticStyle: { width: "100px", cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.gotoOrderDetail(item)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  width: "22px",
                                  display: "inline-block",
                                },
                              },
                              [_vm._v(_vm._s(index + 1))]
                            ),
                            _c("span", [_vm._v(_vm._s(item.webReference))]),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "2px" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.LANG_ZH_EN_PS_LIST.bjGet(
                                        item.failureReason
                                      )
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        !_vm.$store.getters.cusId
                          ? _c(
                              "span",
                              {
                                staticClass: "ellipsis",
                                staticStyle: { width: "140px" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.customerList.bjGet(item.cusId))
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("timeFilters")(item.creationDate, {
                                isSession: true,
                                dateFormat: "DD/MM/YYYY",
                              })
                            )
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.tabStatus == 2
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.dataList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "flex-spacebetween" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "ellipsis",
                              staticStyle: {
                                width: "170px",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.gotoOrderDetail(item)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    width: "22px",
                                    display: "inline-block",
                                  },
                                },
                                [_vm._v(_vm._s(index + 1))]
                              ),
                              _c("span", [_vm._v(_vm._s(item.outerOrderNo))]),
                            ]
                          ),
                        ]
                      )
                    }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("timeFilters")(_vm.item.creationDate, {
                            isSession: true,
                            dateFormat: "DD/MM/YYYY",
                          })
                        )
                      ),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }